(() => {
  const initScroller = (wrapper) => {
    if (wrapper.dataset.colourSwatchScrollInit === 'true') return;

    const list = wrapper.querySelector('.variant-picker__options--colour');
    if (!list) return;

    const prevBtn = wrapper.querySelector('.colour-swatch-scroll__btn--prev');
    const nextBtn = wrapper.querySelector('.colour-swatch-scroll__btn--next');

    wrapper.dataset.colourSwatchScrollInit = 'true';

    const getScrollStep = () => {
      const firstSwatch = list.querySelector('.swatch-link');
      if (!firstSwatch) return list.clientWidth * 0.75;

      const styles = window.getComputedStyle(list);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return firstSwatch.getBoundingClientRect().width + gap;
    };

    const scrollByStep = (direction) => {
      list.scrollBy({
        left: direction * getScrollStep(),
        behavior: 'smooth',
      });
    };

    const setNavVisible = (button, visible) => {
      if (!button) return;
      button.hidden = !visible;
      button.tabIndex = visible ? 0 : -1;
    };

    const update = () => {
      const canScroll = list.scrollWidth > list.clientWidth + 2;
      wrapper.classList.toggle('colour-swatch-scroll--overflow', canScroll);

      if (!canScroll) {
        wrapper.classList.add('colour-swatch-scroll--at-start');
        wrapper.classList.add('colour-swatch-scroll--at-end');
        setNavVisible(prevBtn, false);
        setNavVisible(nextBtn, false);
        return;
      }

      const atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      const atStart = list.scrollLeft <= 2;
      wrapper.classList.toggle('colour-swatch-scroll--at-end', atEnd);
      wrapper.classList.toggle('colour-swatch-scroll--at-start', atStart);

      setNavVisible(prevBtn, !atStart);
      setNavVisible(nextBtn, !atEnd);
    };

    prevBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      scrollByStep(-1);
    });

    nextBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      scrollByStep(1);
    });

    update();
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    list.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', update, { once: true });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(list);
    }
  };

  document.querySelectorAll('[data-colour-swatch-scroll]').forEach(initScroller);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-colour-swatch-scroll]').forEach(initScroller);
  });
})();
